export type AlmeColorProp = 'default' | 'divider' | 'initial' | 'paper' | 'primary' | 'secondary';

interface AlmeColorStyles extends Record<string, unknown> {
    color?: AlmeColorProp;
    children?: React.ReactNode;
}

type AlmeColorsMapping = Record<AlmeColorProp | string, unknown>;

// Like https://github.com/brunobertolini/styled-by
export const styledBy = (property: string, mapping: AlmeColorsMapping) => (props: AlmeColorStyles): string | undefined => {
    return mapping[props[property] as string || 'initial'] as string | undefined;
};
